/*
 * @Description: 拆分player-info组件业务逻辑
 * @Author: fiveonelei
 * @Date: 2022-02-23 19:32:56
 * @FilePath: /app-monorepo-projects/packages/app-share/src/utils/player-info.ts
 */
import { EMiniAppPosition } from '@/constants/mini-app';
import { State } from '@/store/state';
import { ModelMetaFeed, ModelAdInfo } from '@/types/model';
import { IHashMap } from '@/types/data';
import { EFeedReserveType, EMaterialCategory } from '@/constants/feed';
import { report } from '@/libs/report';
import miniApp from './mini-app';


type ReportParams = {
  feed: ModelMetaFeed,
  growthTestData: State['growthTestData'],
  topicId?: string,
  isSupportExposureMaterial?: boolean
};

// 从player-info.vue组件中抽离复杂的上报逻辑
export class PlayerInfoReport {
  reportParams: ReportParams;
  constructor(params: ReportParams) {
    this.reportParams = params;
  };
  report(key: string, extraTypeParams: IHashMap = {}) {
    const { feed } = this.reportParams;
    report(key, {
      ...extraTypeParams,
      video_id: feed.video.fileId,
      owner_id: feed.poster.id,
    });
  };
  reportWithFeedCommonOpt(key: string, tag?: EMiniAppPosition, extraTypeParams: IHashMap = {}) {
    this.report(key, {
      ...extraTypeParams,
      ...this.getFeedCommonReportOpt(tag),
    });
  };
  getFeedCommonReportOpt(tag?: EMiniAppPosition) {
    const { growthTestData } = this.reportParams;
    return {
      type: {
        jump_miniApp: tag && miniApp.getMiniAppReportValue(tag, { growthTestData }),
      },
    };
  };
  exposureMaterialInfo() {
    return this.reportParams.feed.reserve[EFeedReserveType.exposureMaterialInfo] || {};
  };
  exposureMaterialReportOpt() {
    const { materialCategory, materialId } = this.exposureMaterialInfo();
    const reportOpt = {
      interact_mode_id: materialCategory === EMaterialCategory.wsInteractTemplate ? materialId : '',
      mode_id: materialCategory === EMaterialCategory.videofunny ? materialId : '',
      magic_id: materialCategory === EMaterialCategory.camera ? materialId : '',
      movie_id: materialCategory === EMaterialCategory.recommendTemplate ? materialId : '',
      h5material_id: materialCategory === EMaterialCategory.h5Activity ? materialId : '',
    };
    return reportOpt;
  };
  reportLike(type: string) {
    const { materialCategory, materialId } = this.exposureMaterialInfo();
    const { growthTestData, topicId } = this.reportParams;

    this.report(`video.like.${type}`, {
      type: {
        interact_mode_id: materialCategory === EMaterialCategory.wsInteractTemplate ? materialId : '',
        topic_id: topicId,
        jump_miniApp: miniApp.getMiniAppReportValue(EMiniAppPosition.videoLike, { growthTestData }),
      },
    });
  };
  mountedReport() {
    const { topicId, isSupportExposureMaterial } = this.reportParams;

    this.reportWithFeedCommonOpt('video.share.exposure');
    this.reportWithFeedCommonOpt('video.headpic.exposure', EMiniAppPosition.videoHeadpic);
    this.reportWithFeedCommonOpt('video.headpic.focus.exposure', EMiniAppPosition.videoHeadpicFocus);
    this.reportLike('exposure');
    if (topicId) {
      this.report('video.topic.exposure', {
        type: { topic_id: topicId },
      });
    }
    if (isSupportExposureMaterial) {
      this.report('video.cameratoo.exposure', {
        type: {
          ...this.exposureMaterialReportOpt(),
        },
      });
    }
  };
  // 商品卡上报
  cardReport(typeData: string, params: { adInfo: ModelAdInfo, currentTime: number}) {
    if (!params.adInfo) return;
    enum EAdreportType {
      type1 = '100',
      type2 = '200',
    }
    const {
      traceInfo,
      goodsMaterialInfo: { goodsInfo },
    } = params.adInfo;
    const adStr = traceInfo.ad_str;
    const shopInfo = goodsInfo.hasCoupon ? '2' : '1'; // 是否有优惠券
    const typeCom = typeData.includes('click')
      ? {
        video_showtime: parseInt(String(params.currentTime * 1000), 10),
        adreport_type: EAdreportType.type1,
      }
      : {
        adreport_type: EAdreportType.type2,
      };
    this.report(typeData, {
      type: {
        ...typeCom,
        jump_type: 'deeplink',
        ad_str: adStr,
        shop_info: shopInfo,
      },
    });
  };
}

